import moment from 'moment';
import React from 'react';

import sendFeedback, { feedbackUrl } from '../../../service/feedbackService';
import type { PushAlert } from '../page';
import FeedbackModal from './FeedbackModal';

export type SubmitFeedbackFormProps = {
  form: {
    message: {
      value: string,
    },
    subject: {
      value: string,
    },
  },
  path: string,
  pushAlert: PushAlert,
};

const submitFeedbackForm = ({
  form,
  path,
  //this is passed in and not just imported b/c we want the specific one from the specific page's context
  pushAlert,
}: SubmitFeedbackFormProps): void => {
  const body = {
    subject: `Trip Center Support: ${form?.subject?.value}`,
    message: form?.message?.value,
    userAgent: navigator?.userAgent,
    submitted: moment().format('YYYY-MM-DDTHH:MM:SSZ'),
    context: path,
  };
  sendFeedback(body)
    .then(response => {
      if (!response.ok) {
        const { status, statusText } = response;
        pushAlert(
          'danger',
          `Sorry, there's been an error submitting your feedback. '${status} ${statusText}'`,
        );
        console.error(
          `Error attempting to submit user feedback at '${feedbackUrl}', w/ body ${JSON.stringify(
            body,
          )} '${status} ${statusText}'`,
        );
      }
    })
    .catch(error => {
      pushAlert(
        'danger',
        "Sorry, there's been an error submitting your feedback.",
      );
      console.error(
        `Error attempting to submit user feedback at '${feedbackUrl}'`,
        error,
      );
    });
};

type FeedbackModalContainerProps = {
  showModal: boolean,
  closeModal: () => void,
};

const FeedbackModalContainer = ({
  showModal,
  closeModal,
}: FeedbackModalContainerProps) => {
  return (
    <FeedbackModal
      showModal={showModal}
      closeModal={closeModal}
      onSubmit={submitFeedbackForm}
    ></FeedbackModal>
  );
};

export default FeedbackModalContainer;
